import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import WYSIWYGEditor from '../../../WYSIWYGEditor'
import { buildValidationRules } from '../utils/fieldUtils'

function MarkdownFieldEditor ({ field, control, form }) {
  const rules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  // Transform onChange to match react-hook-form's event pattern
  const handleChange = useCallback((onChange) => (value) => {
    onChange({ target: { value } })
  }, [])

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <WYSIWYGEditor
            defaultValue={hookField.value}
            onChange={handleChange(hookField.onChange)}
            placeholder={field.placeholder || field.label}
            isMarkdown
          />
        </SydLabel>
      )}
    />
  )
}

MarkdownFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default MarkdownFieldEditor
